import { createAction, props } from '@ngrx/store';

import { ManureRequest, ManureRequestModel } from '../../models/manure-request.model';

export const sendManureRequest = createAction(
  '[Request] Send Manure Request',
  props<{ request: ManureRequest }>(),
);

export const sendManureRequestSuccess = createAction(
  '[Request] Send Manure Request Success',
  props<{ response: ManureRequestModel }>(),
);
